import React from 'react';

const RenderIntroWork = (props) => {
    const { fields } = props;

    const WorkPartners = () => {
        return (
            fields.work_partners.length > 0 && (
                <div className="col-xs-12 col-sm-4 col-md-4 no-padding">
                    <h3>Partners</h3>
                    <ul>
                        {fields.work_partners.map((field, index) => (
                            <li key={index}>{field.work_partner_title}</li>
                        ))}
                    </ul>
                </div>
            )
        );
    };

    const WorkExpertises = () => {
        return (
            fields.work_expertises.length > 0 && (
                <div className="col-xs-12 col-sm-4 col-md-8 no-padding">
                    <h3>Expertises</h3>
                    <ul className="column-list-2">
                        {fields.work_expertises.map((field, index) => {
                            return (
                                <li key={index}>
                                    {field.work_expertise_title}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )
        );
    };

    return (
        <div className="work__intro">
            <p className="intro">{fields.work_introtxt}</p>
            <div className="row">
                <WorkPartners />
                <WorkExpertises />
            </div>
        </div>
    );
};

export default RenderIntroWork;



// WEBPACK FOOTER //
// ./src/components/Pages/Work/RenderIntroWork.jsx